export const statuses = {
    UNAVAILABLE: 'UNAVAILABLE',
    ENABLED: 'ENABLED',
    DISABLED: 'DISABLED',
    ENABLING: 'ENABLING',
    DISABLING: 'DISABLING',
};
